<template>
    <slot></slot>
</template>
<script setup>
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { onMounted } from 'vue';

gsap.registerPlugin(ScrollTrigger);

onMounted(()=>{
    let tl = gsap.timeline({
        scrollTrigger:{
            trigger:'.welcome',
            start(){
                return 'top center+=' + document.querySelector('header.main').offsetHeight
            }
        }
    });

    tl.to('.welcome .copy', {
        autoAlpha:1
    });

    tl.to('.welcome .bobblehead', {
        autoAlpha:1,
        x:0
    }, 0.15);


    let tlGiveaway = gsap.timeline({
        scrollTrigger:{
            trigger:'.giveaway',
            start(){
                return 'top center+=' + document.querySelector('header.main').offsetHeight
            }
        }
    });

    tlGiveaway.to('.giveaway .jug', {
        autoAlpha:1,
        x:0
    });

    tlGiveaway.to('.giveaway .copy', {
        autoAlpha:1
    }, 0.15);

    let tlCheckback = gsap.timeline({
        scrollTrigger:{
            trigger:'.checkback',
            start(){
                return 'top center+=' + document.querySelector('header.main').offsetHeight
            }
        }
    });

    tlCheckback.to('.checkback .copy', {
        autoAlpha:1
    });

    tlCheckback.to('.checkback li', {
        autoAlpha:1,
        y:0,
        stagger:0.1
    });




});

</script>
